module.exports = __webpack_public_path__ + "static/media/pana.a62c3dd1.svg";